"use client"

import { motion, AnimatePresence } from "framer-motion"
import { usePathname } from "next/navigation"
import { ReactNode, useEffect, useState } from "react"

interface PageTransitionProps {
  children: ReactNode
}

export function PageTransition({ children }: PageTransitionProps) {
  const pathname = usePathname()
  const [isAnimating, setIsAnimating] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [displayChildren, setDisplayChildren] = useState(children)

  useEffect(() => {
    // Show loading immediately
    setIsLoading(true)
    setIsAnimating(true)
    
    // Update displayed children immediately to show new page
    setDisplayChildren(children)
    
    const animationTimer = setTimeout(() => setIsAnimating(false), 2500)
    const loadingTimer = setTimeout(() => setIsLoading(false), 800)
    
    return () => {
      clearTimeout(animationTimer)
      clearTimeout(loadingTimer)
    }
  }, [pathname, children])

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="relative"
      >
        {/* Top Loading Bar */}
        {isLoading && (
          <motion.div
            className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary via-primary/80 to-primary z-[100] origin-left"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            exit={{ scaleX: 1, opacity: 0 }}
            transition={{ 
              scaleX: { duration: 0.6, ease: "easeOut" },
              opacity: { duration: 0.2, delay: 0.4 }
            }}
          />
        )}
        
        {/* Plane fly-in animation on page load
        {isAnimating && (
          <motion.div
            initial={{ x: "-100vw", opacity: 0 }}
            animate={{ x: "100vw", opacity: [0, 1, 1, 0] }}
            transition={{ 
              duration: 2.5, 
              ease: "easeInOut",
              opacity: {
                times: [0, 0.2, 0.8, 1],
                duration: 2.5
              }
            }}
            className="fixed top-1/2 left-0 z-[100] pointer-events-none -translate-y-1/2"
          >
            <img
              src="/images/plane.webp" 
              alt="Transition animation"
              className="w-full h-auto"
            />
          </motion.div>
        )} */}
        
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
